import "./benefitsHead.scss";
import Typography from "../../../../../common/Typography";

const BenefitsHead = () => {
  return (
    <div className="benefits-head">
      <div className="left-stroke"></div>
      <Typography tag="span" weight="medium">
        Benefits
      </Typography>
      <div className="right-stroke"></div>
    </div>
  );
};

export default BenefitsHead;
